import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import successIcon from './images/assets/success.svg';
import failIcon from './images/assets/fail.svg';
import beerLoader from './images/animations/beerLoader.gif';

const ReturnHandler = () => {
    const [decryptedData, setDecryptedData] = useState(null);
    const [error, setError] = useState(null);
    const [isProcessing, setIsProcessing] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        let resCode = urlParams.get('res_code');

        // For testing
        if (!resCode) {
            //Success
            //resCode = 'RThRMDZjbUdzaUVzWmZpVlpTOXVOdVZhZGdmQkRCRXNreE1lYkYyK0NsdDhacFIzVXdBb2IyZmJqam54WWQ5NkpMZEs4dnhTaEFxZjJGMGp4WDdoNkhHVUNNSXlicTU2T1R2aEJDQWo2OGo3RFROMzNqZGZscG9tRHZpbUdHSmtMWi9uQ0o2MWlyL0hWUE9KVit2RG9kbkNCOTFSZ3NpN1NjNVNjd1hHYnp4amdnQmV2bk5xMktnVnRIcGoyazJyMzBuNFhnUitQQ2lmWkZDaVJRTlZFYmhSanRPU1RvaUMzSnFhZjBLeDdudEVvcUY2NnpSZkRZOGN0bm8wc1VqZg==';
            //Fail
            //resCode = 'MnIvVVl6UU1tWmpLS002ZWVrYWtqWDQ5UDVDbWkreENlcUlEeVpXN2lMeE92K1cxSm5kSElJbmVxbWlZOSszZG9XSHFRQXRJUHl0VHJoNXg4dmQ2T0xHVFh3RDVtRC9yUEZZdjExTkNLMTB0ektjTFJTdnBoKy9CTUlZOUFXd2FlQ3ZOM0w4NHY3MmdBZ3RMZ0xoWDliaUo5d25icEhnUkNjUnBEZnBnS1I5Vjh1UUFvWURqQ2Z1cmVteTRVTCtGNDlUbk9sRHgrOXRRM0NFVERoL2tHZz09';
        }

        if (resCode) {
            decryptOnServer(resCode);
        } else {
            setError("Invalid response");
            setIsProcessing(false);
        }
    }, []);

    const decryptOnServer = async (code_res) => {
        try {
            const response = await axios.post('/api/decrypt-message', { code_res });
            const data = response.data;

            setDecryptedData(data.decryptedData || JSON.parse(data.message));
            setIsProcessing(false);

        } catch (err) {
            console.error('Failed to decrypt:', err);
            setError('An error occurred while processing the payment return.');
            setIsProcessing(false);
        }
    };

    const returnHome = () => navigate('/');

    // Show loader while processing
    if (isProcessing) {
        return (
            <div className='overlay'>
                <div className='animationContainer'>
                    <img src={beerLoader} alt='loading' className='loadingAnimation' />
                    <p>Processing Payment...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return <div className='page-content'>Error: {error}</div>;
    }

    const statusCode = decryptedData?.statusCode;

    return (
        <div className='page-content'>
            <div className='login-form-container'>
                <div className='content-center'>
                    {statusCode === 200 ? (
                        <img src={successIcon} className='statusIcon' alt="success" />
                    ) : (
                        <img src={failIcon} className='statusIcon' alt="failed" />
                    )}

                    <p>{decryptedData?.message || 'Payment processed'}</p>
                    {decryptedData?.transaction_id > 0 && (
                        <p>Transaction ID: {decryptedData.transaction_id}</p>
                    )}

                    <button onClick={returnHome} className='actionButton'>
                        RETURN HOME
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReturnHandler;